import axios from 'axios';
import store  from '../store';

const shoppingCart = {
  requesting: false,
  purchaseId() {
    let purchaseId = 0;
    switch (store.state.order.service) {
      case "on_table":
        purchaseId = store.state.order.purchaseId;
        return purchaseId;
      case "book":
        purchaseId = store.state.bookings.bookPurchaseId;
        return purchaseId;
      case "delivery":
        purchaseId = store.state.order.purchaseId;
        return purchaseId;
      case "take_away":
        purchaseId = store.state.order.taPurchaseId;
        return purchaseId;
    };
  },
  modifyProduct(productId, count) {
    return new Promise((resolve, reject) => {
      let purshaseId = 0;
      if(store.state.order.service === 'delivery')  purshaseId = store.state.order.purchaseId;
      if(store.state.order.service === 'take_away')  purshaseId = store.state.order.taPurchaseId;
      if(store.state.order.service === 'on_table')  purshaseId = store.state.order.otPurchaseId;
      axios({
        method: "put",
        url: `${process.env.VUE_APP_API_EXP}/shopping_cart/product_cart/${productId}.json?purchase_id=${purshaseId}`,
        headers: {
          profileid: store.state.profile.profile.id,
          token: store.state.profile.profile.token
        },
        data:{
          product:{count: count}
        }
      }).then(
          response => {
            resolve(response.data);
          }
      ).catch(error => {
        reject(error)
      });
    })
  },
  RemoveProduct(productId) {
    return new Promise((resolve, reject) => {
      let purshaseId = 0;
      if(store.state.order.service === 'delivery')  purshaseId = store.state.order.purchaseId;
      if(store.state.order.service === 'take_away')  purshaseId = store.state.order.taPurchaseId;
      if(store.state.order.service === 'on_table')  purshaseId = store.state.order.otPurchaseId;
      axios({
        method: "delete",
        url: `${process.env.VUE_APP_API_EXP}/shopping_cart/product_cart/${productId}.json?purchase_id=${purshaseId}`,
        headers: {
          profileid: store.state.profile.profile.id,
          token: store.state.profile.profile.token
        }
      }).then(
          response => {
            resolve(response.data);
          }
      ).catch(error => {
        reject(error.message)
      });
    });
  },
  getProductsCart() {
    if(this.purchaseId().toString().length) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: `${process.env.VUE_APP_API_EXP}/shopping_cart/cart/${this.purchaseId()}.json`,
          headers: {
            profileid: store.state.profile.profile.id,
            token: store.state.profile.profile.token
          }
        }).then(
          response => {
            resolve(response.data);
          }
        ).catch(error => {
          reject(error.message)
        });
      });
    };
  },
  getProductsCartById(purchaseId) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.VUE_APP_API_EXP}/shopping_cart/cart/${purchaseId}.json`,
        headers: {
          profileid: store.state.profile.profile.id,
          token: store.state.profile.profile.token
        }
      }).then(
          response => {
            resolve(response.data);
          }
      ).catch(error => {
        reject(error.message)
      });
    })
  },
  async modifyCart(data, product_status) {
    let purshaseId = 0;
    if (store.state.order.service === 'delivery')  purshaseId = store.state.order.purchaseId;
    if (store.state.order.service === 'take_away')  purshaseId = store.state.order.taPurchaseId;
    if (store.state.order.service === 'on_table')  purshaseId = store.state.order.otPurchaseId;
    return axios({
      method: "put",
      url: `${process.env.VUE_APP_API_EXP}/shopping_cart/cart/${purshaseId}.json?purchase_id=${purshaseId}`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data:{
        cart: data,
        product_status: product_status
      }
    }).then(
      response => {
        response
      }
    )
  },
  AddProductToCart(product,purchaseId,data_purchase) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/shopping_cart/add_product_cart`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: {
        product: product,
        purchase_id: purchaseId,
        data_purchase: data_purchase
      }
    })
  },
  BookAddProductToCart(purchaseId,data_purchase,product = {}) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/shopping_cart/add_product_to_book`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: {
        purchase_id: purchaseId,
        data_purchase: data_purchase,
        product: product
      }
    })
  },
  deleteProductBook(id) {
    return axios({
      method: "delete",
      url: `${process.env.VUE_APP_API_EXP}/shopping_cart/add_product_to_book/${id}`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      }
    });
  },
  changeCartSupplier(id,supplier_id,data) {
    return axios({
      method: "put",
      url: `${process.env.VUE_APP_API_EXP}/shopping_cart/change_supplier/${id}.json?supplier_id=${supplier_id}`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: { cart: data }
    });
  },
  changeCartSupplierMsg(id,supplier_id,data) {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/shopping_cart/change_supplier/${id}.json?supplier_id=${supplier_id}`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: { cart: data }
    });
  },
  deleteAllProductsInCart () {
    let id = null;
    if(store.state.order.purchaseId) id = store.state.order.purchaseId;
    else id = store.state.order.taPurchaseId;
    return axios({
      method: "DELETE",
      url: `${process.env.VUE_APP_API_EXP}/shopping_cart/clean_cart/${id}.json`
    });
  }
}

export { shoppingCart }
